import React from "react";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import AddEmployee from "../Registration/Employee/addEmployee";
import AltEmployee from "../Registration/Employee/altEmployee";
import DelEmployee from "../Registration/Employee/delEmployee";
import BottomBar from "../../Components/bottomBar/bottomBar";
import "./prelude.css";
import Api from "../../services/api";
import Alert from "../../Components/alert/Alert";
import TopBar from "../../Components/topBar/topBar";
import { handleColor } from "../../services/Functions";
import ReportEmployees from "../Reports/reportEmployees";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";

const PreludeEmployees = () => {
  const [activeTab, setActiveTab] = React.useState("list");
  return (
    <>
      <header>
        <TopBar></TopBar>{" "}
      </header>
      <main className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </main>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = { data: [], keys: [], render: false, message: "", click: false };

  async componentDidMount() {
    let array = [];
    await Api.get("/employees")
      .then((response) => {
        response.data.response.forEach((element) => {
          array.push({
            Nome: element.name,
            Código: element.employee_code,
            Ativo: element.is_active ? "Sim" : "Não",
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const items = [
      { id: "lg1", label: "Funcionários", eventKey: "list" },
      { id: "lg2", label: "Adicionar Funcionário", eventKey: "add" },
      { id: "lg3", label: "Alterar Funcionário", eventKey: "alt" },
      { id: "lg4", label: "Deletar Funcionário", eventKey: "del" },
    ];
    const { show, message } = this.state;
    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1 ">
            <div
              className={this.props.isMobile ? "sidebar2-mobile" : "sidebar2"}
            >
              <Col className="sidebarColumn" mountOnEnter unmountOnExit>
                <ListGroup>
                  {items.map((item) =>
                    this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            this.props.handleClose();
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    )
                  )}
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "2%",
                marginLeft: "1%",
                width: "100%",
                height: "96%",
                overflow: "hidden",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content style={{ height: "100%" }}>
                <Tab.Pane style={{ height: "100%" }} eventKey="list">
                  {this.handleClick ? <ReportEmployees /> : null}
                </Tab.Pane>
                <Tab.Pane style={{ height: "100%" }} eventKey="add">
                  {this.handleClick ? <AddEmployee /> : null}
                </Tab.Pane>
                <Tab.Pane style={{ height: "100%" }} eventKey="del">
                  {this.handleClick ? <DelEmployee /> : null}
                </Tab.Pane>
                <Tab.Pane style={{ height: "100%" }} eventKey="alt">
                  {this.handleClick ? <AltEmployee /> : null}
                </Tab.Pane>
                <Tab.Pane style={{ height: "100%" }} eventKey="del">
                  {this.handleClick ? <DelEmployee /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default PreludeEmployees;
